import Images from "./images"

export const MANUAL_FIELD = {
  id: "manual",
  name: "Manual",
  valueType:-3
}

export const NONE_FIELD = {
  id: "-1",
  name: "Immediate Implementation",
  isNone: true,
  valueType:-1
}
// export const NA_FIELD = {
//   id: "-1",
//   name: "NA",
//   isNone: true,
//   valueType:-1
// }
export const EXCLUDE_FIELD = {
  id: "-2",
  name: "Exclude",
  isNone: true,
  valueType:-2
}

export const TYPE_OF_METHODS: any = {
  GET: "get",
  POST: "post",
  PUT: "put",
  PATCH: "patch",
}

export const ProductsList: Array<{
  id: number
  label: string
  title: string
  activeIcon: string
  isactive: any
  icon: string
}> = [
  {
    id: 2,
    title: "Digital Experience",
    label: "Aternity",
    activeIcon: Images.aternityactive,
    icon: Images.aternity,
    isactive: true,
  },
  {
    id: 3,
    title: "Network Observability",
    label: "NPM",
    activeIcon: Images.npmactive,
    icon: Images.npm,
    isactive: true,
  },
  {
    id: 4,
    title: "AIOps",
    label: "IQ",
    activeIcon: Images.iqactive,
    icon: Images.iq,
    isactive: true,
  },
   {
    id: 5,
    title: "Acceleration",
    label: "Acceleration",
    activeIcon: Images.Accelerationactive,
    icon: Images.Acceleration,
    isactive: true,
  },
  {
    id: 6,
    title: "Digital Mobile Experience",
    label: "Aternity Mobile",
    activeIcon: Images.Atternity_mobile_Active,
    icon: Images.Atternity_mobile,
    isactive: true,
  },
  {
    id: 7,
    title: "APM",
    label: "APM",
    activeIcon: Images.Accelerationactive,
    icon: Images.Acceleration,
    isactive: true,
  },
  
]
export const UserList: Array<{
  id: number
  title: string
  activeIcon: string
  isactive: any
  icon: string
  description:any
}> = [
  {
    id: 1,
    title: "New Business ",
    activeIcon: Images.NewBusinessactiveicon,
    icon: Images.NewBusinessicon,
    isactive: true,
    description:"For new  customers  or new business with  existing customers"
  },
  {
    id: 2,
    title: "Ongoing Customer​",
    activeIcon: Images.ExpansionExistingCustomeractive,
    icon: Images.ExpansionExistingCustomer,
    isactive: true,
    description:"For  reviewing the ROI currently being achieved by  existing customers"  },
  {
    id: 3,
    title: "Renewal​",
    activeIcon: Images.RenewalExistingCustomeractive,
    icon: Images.RenewalExistingCustomer,
    isactive: true,
    description:"For existing customers who are renewing their contract"

  },
  {
    id: 4,
    title: "Consolidation Proposal",
    activeIcon: Images.ConsolidationBusiness,
    icon: Images.ConsolidationBusiness,
    isactive: true,
    description:"For customers looking to replace and consolidate their existing observability tools with the Riverbed platform"

  },
 
]
export const configCoverage:any = {
  1: "Aternity On Prem",
  2: "Aternity SaaS Fundamental",
  3: "Aternity SaaS Essential",
  4: "Aternity App Add On",
  5: "Aternity SaaS Enterprise",
  6: "Aternity Intel Module",
  7: "Other DEX/DEM Products",
  8: "Aternity Mobile",
  9: "Other Mobile DEX/DEM Products",
  10: "App Response",
  11: "Net Profiler",
  12: "NETIM",
  13: "NPM+",
  14: "UC Module",
  15: "Other Flow Base NPM",
  16: "Other Packet Based NPM",
  17: "Other Network Infrastructure Monitor NPM",
  18: "IQ",
  19: "Other AI Ops Products",
  20: "SteelHead",
  21: "Other Acceleration Products",
  22: "APM",
  23: "Other APM Products"
}
export const productData: Array<{
  id: any;
  name: string;
  category: string;
  vendor: string;
  backgroundColor: string;
  buttonColor: string;
  disableColor:string;
  PreName?:string;
  subProd:Array<{
    id: any;
    subname: string;
    addOnsProducts?:any;
    PreSubName?:any;
  }>;
  // addOnsProducts?:any;
  otherProduct?: Array<{
    id: any;
    subname: string;
  }>;
  otherLabel?: string;
  otherOptions?: string[];
  icon: any;
  renewalButton:any;
}> = [
   {
    id: -1,
    name: "",
    PreName:"New Customer with no existing tools",
    category: "No Commercial Proposal",
    vendor: "riverbed",
    backgroundColor: "linear-gradient(142deg, rgba(78, 79, 168, 0.10) -2.24%, rgba(132, 66, 202, 0.10) 100%), #FFF;",
    buttonColor: "linear-gradient(142deg, #4E4FA8 -2.24%, #8442CA 100%)",
    disableColor:"linear-gradient(250.34deg, rgba(243, 92, 93, 0.35) 0.13%, rgba(188, 23, 177, 0.35) 103.66%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))",
    renewalButton:"linear-gradient(250.34deg,#F35C5D .13%,#BC17B1 103.66%)",
    icon: Images.NewNoExistingtools,
    subProd: [
      { 
        id: -1, 
        subname: "No New Products",
        PreSubName:"No Existing Products",
        addOnsProducts:[]
      },
     ],
    otherProduct:[]
  },
  {
    id: 2,
    name: "Aternity",
    category: "Digital Experience",
    vendor: "riverbed",
    backgroundColor: "linear-gradient(142deg, rgba(78, 79, 168, 0.10) -2.24%, rgba(132, 66, 202, 0.10) 100%), #FFF;",
    buttonColor: "linear-gradient(142deg, #4E4FA8 -2.24%, #8442CA 100%)",
    disableColor:"linear-gradient(250.34deg, rgba(243, 92, 93, 0.35) 0.13%, rgba(188, 23, 177, 0.35) 103.66%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))",
    renewalButton:"linear-gradient(250.34deg,#F35C5D .13%,#BC17B1 103.66%)",
    icon: Images.AtternityConsolidate,
    subProd: [
    { 
      id: 1, 
      subname: "Aternity On Prem",
      addOnsProducts:[]
    },
    { 
      id: 2,
      subname: "Aternity SaaS Fundamentals",
      addOnsProducts:[]
    },
    { 
      id: 3, 
      subname: "Aternity SaaS Essentials",
      addOnsProducts:[
                      {
                        addOnId: 4, addOnsName: "App Add Ons",
                      },
                      {
                        addOnId: 6, addOnsName: "Aternity Intel Module",
                      }
                    ]
    },
    { 
      id: 5, 
      subname: "Aternity SaaS Enterprise",
      addOnsProducts:[
        {
          addOnId: 6, addOnsName: "Aternity Intel Module",
        }
      ]
    }
  ],
    otherProduct: [
  { id: 7, subname: "Other DEX/DEM product" },
]
  },
  {
    id: 6,
    name: "Aternity Mobile",
    category: "Digital Mobile Experience",
    vendor: "riverbed",
    backgroundColor: "linear-gradient(142deg, rgba(132, 66, 202, 0.10) -2.18%, rgba(194, 32, 175, 0.10) 99.93%), #FFF;",
    buttonColor: "linear-gradient(142deg, #8442CA -2.18%, #C220AF 99.93%)",
    disableColor:"linear-gradient(250.34deg, rgba(243, 92, 93, 0.35) 0.13%, rgba(188, 23, 177, 0.35) 103.66%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))",
    renewalButton:"linear-gradient(142.43deg,#554DAC -2.24%,#DD0193)",
    icon: Images.Atternity_mobileConsolidate,
    subProd: [
    { id:8, subname: "Aternity Mobile" }
  ],
    otherProduct: [
  { id: 9, subname: "Other Mobile DEX/DEM product" },
]
  },
  {
    id: 3,
    name: "NPM",
    category: "Network Observability",
    vendor: "riverbed",
    backgroundColor: "linear-gradient(102deg, rgba(222, 3, 155, 0.10) 18.84%, rgba(243, 73, 109, 0.10) 82.76%), #F9F9F9",
    buttonColor: "linear-gradient(266deg, #DE039B -0.36%, #C220AF 100.73%)",
    disableColor:"linear-gradient(250.34deg, rgba(243, 92, 93, 0.35) 0.13%, rgba(188, 23, 177, 0.35) 103.66%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))",
    renewalButton:"linear-gradient(142.17deg,#A12CCF -2.18%,#D2099D 99.93%)",
    icon: Images.NpmConsolidate,
    subProd: [
    { id: 10, subname: "AppResponse" }, //------
    { id: 11, subname: "NetProfiler" },//------
    { id: 12, subname: "NETIM" },
    { 
      id: 13, 
      subname: "NPM+",
      addOnsProducts:[
        {
          addOnId: 14, addOnsName: "UC Module",//------
        }
      ]
     }//------  
  ],
    otherProduct: [
  { id: 15, subname: "Other flow-based NPM" },
  { id: 16, subname: "Other packet-based NPM" },
  { id: 17, subname: "Other network infrastructure monitoring NPM" },
]
  },
  {
    id: 4,
    name: "IQ",
    category: "AIOps",
    vendor: "riverbed",
    backgroundColor: "linear-gradient(102deg, rgba(222, 3, 155, 0.10) 18.84%, rgba(243, 73, 109, 0.10) 82.76%), #FFF;",
    buttonColor: "linear-gradient(102deg, #DE039B 18.84%, #F3496D 82.76%)",
    disableColor:"linear-gradient(250.34deg, rgba(243, 92, 93, 0.35) 0.13%, rgba(188, 23, 177, 0.35) 103.66%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))",
    renewalButton:"linear-gradient(250.34deg,#F35C5D .13%,#BC17B1 103.66%)",
    icon: Images.IqConsolidate,
    subProd: [
    { id: 18, subname: "IQ" }
  ],
    otherProduct: [
  { id: 19, subname: "Other AIOps product" },
]
  },
  {
    id: 5,
    name: "Acceleration",
    category: "Acceleration",
    vendor: "riverbed",
    backgroundColor: "linear-gradient(102deg, rgba(243, 73, 109, 0.10) 30.23%, rgba(252, 145, 82, 0.10) 82.76%), #FFF;",
    buttonColor: "linear-gradient(102deg, #F3496D 30.23%, #FC9152 82.76%)",
    disableColor:"linear-gradient(250.34deg, rgba(243, 92, 93, 0.35) 0.13%, rgba(188, 23, 177, 0.35) 103.66%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))",
    renewalButton:"linear-gradient(101.95deg,#F35C5D 30.23%,#F7B34C 82.76%)",
    icon: Images.AccelerationConsolidate,
    subProd: [
    { id: 20, subname: "Steelhead" }
  ],
    otherProduct: [
  { id: 21, subname: "Other Acceleration Product" },
]
  },
  {
    id: 7,
    name: "APM",
    category: "APM",
    vendor: "riverbed",
    backgroundColor: "linear-gradient(142deg, rgba(78, 79, 168, 0.10) -2.24%, rgba(132, 66, 202, 0.10) 100%), #FFF;",
    buttonColor: "linear-gradient(142deg, #4E4FA8 -2.24%, #8442CA 100%)",
    disableColor:"linear-gradient(250.34deg, rgba(243, 92, 93, 0.35) 0.13%, rgba(188, 23, 177, 0.35) 103.66%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))",
    renewalButton:"linear-gradient(250.34deg,#F35C5D .13%,#BC17B1 103.66%)",
    icon: Images.NewNoExistingtools,
    subProd: [
      { 
        id: 22, 
        subname: "APM",
        PreSubName:"No Existing Products",
        addOnsProducts:[]
      },
     ],
    otherProduct: [
       { 
        id: 23, 
        subname: "Other APM Product"
       },
     ]
  }
];

export const UserRoiTypes: Array<{
  id: number
  title: string
  activeIcon: string
  isactive: any
  icon: string
  description:any
}> = [
  {
    id: 1,
    title: "Federal Business",
    activeIcon: Images.FederalBusiness,
    icon: Images.FederalBusiness,
    isactive: true,
    description:"For new  customers  or new business with  existing customers"
  },
  {
    id: 2,
    title: "Internal Business",
    activeIcon: Images.InternalBusiness,
    icon: Images.InternalBusiness,
    isactive: true,
    description:"For  reviewing the ROI currently being achieved by  existing customers"  },
]
// functional code
export const isDisabledBySubInputCheck = (updatedProduct:any, selectedProduct:any, input: any, key: string): boolean => {
  if (
    "typeOfSubInput" in input &&
    key === "estimateNew" &&
    !updatedProduct.includes(Number(input.typeOfSubInput))
  ) {
    return true;
  }

  if (
    "typeOfSubInput" in input &&
    key === "estimateExisting" &&
    !selectedProduct.includes(Number(input.typeOfSubInput))
  ) {
    return true;
  }

  return false;
};
// export const isDisabledByRenewalSubInputCheck = (updatedProduct:any, selectedProduct:any, input: any, key: string): boolean => {
//   const updatedRenewalProduct = [...new Set([...selectedProduct,...updatedProduct])]
//   if (
//     "typeOfSubInput" in input &&
//     key === "estimateNew" &&
//     !updatedRenewalProduct.includes(Number(input.typeOfSubInput))
//   ) {
//     return true;
//   }

//   if (
//     "typeOfSubInput" in input &&
//     key === "estimateExisting" &&
//     !selectedProduct.includes(Number(input.typeOfSubInput))
//   ) {
//     return true;
//   }

//   return false;
// }; 
export const findCombination = (
  arr: string,
  estimates: Array<number>,
  isExact?: boolean
) => {
  let isAvailable = false
  if (!isExact) {
    for (const estimate of estimates) {
      if (arr?.includes(String(estimate))) {
        isAvailable = true
      }
    }
  } else {
    if (arr.length > 2) {
      const estimateCombi: any = []
      for (let i = 0; i < estimates.length; i++) {
        for (let j = i; j < estimates.length; j++) {
          if (estimates[i] !== estimates[j])
            estimateCombi.push(`${estimates[i]},${estimates[j]}`)
        }
      }
      isAvailable = estimateCombi.includes(arr)
    } else {
      isAvailable = estimates.join(",").includes(arr)
    }
  }
  return isAvailable
}


export const findChildCombination = (
  arr: string,
  estimates: Array<number>,
  isExact?: boolean
) => {
  let isAvailable = false;

  const arrValues = arr
    .split(",")
    .map((val) => parseInt(val.trim()))
    .filter((val) => !isNaN(val));

  if (!isExact) {
    isAvailable = arrValues.some((val) => estimates.includes(val));
  } else {
    if (arrValues.length > 1) {
      const estimateCombi: string[] = [];
      for (let i = 0; i < estimates.length; i++) {
        for (let j = i + 1; j < estimates.length; j++) {
          estimateCombi.push(`${estimates[i]},${estimates[j]}`);
        }
      }
      isAvailable = estimateCombi.includes(arrValues.join(","));
    } else {
      isAvailable = estimates.includes(arrValues[0]);
    }
  }

  return isAvailable;
};

export default {
  GENERATE_ROI_STEP: "Please click 'Generate ROI' to proceed further.",
  NEXT_BUTTON_ERROR_MESSAGE: "Please click ‘Next’ to proceed further.",
}
